import { Service } from '../services/Service';
import { BehaviorSubject, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '@env/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/** `/user`-shaped payload for local dev when `environment.useMockSessionUser` is true. */
const MOCK_SESSION_USER_RESPONSE = {
    username: 'socio34991',
    email: 'socio.mock@clubinter.local',
    member_number: '34991',
    club_member: {
        DNI: '29709075',
        IdSocio: '34991',
        NombrePrimero: 'Socio',
        NombreSegundo: '',
        ApellidoPaterno: 'Prueba',
        ApellidoMaterno: '',
        name: 'Socio',
        last_name: 'Prueba',
    },
};
const resolveUserInfo = (raw) => (Object.assign({}, raw, { backgroundImg: raw.background_img, createdAt: raw.created_at, updatedAt: raw.updated_at, memberNumber: raw.member_number, emailConfirmed: raw.email_confirmed, profileImg: raw.profile_img, clubMember: raw.club_member }));
const ɵ0 = resolveUserInfo;
export class MemberService extends Service {
    constructor(_http) {
        super();
        this._http = _http;
        this._appUser$ = new BehaviorSubject(null);
        this.appUser$ = this._appUser$.asObservable();
    }
    getMembershipInfo() {
        return this._http.get(this.API_ENDPOINT_API_INTERSOCIO + 'membership/index', this.APP_REQUEST_OPTIONS_AUTH);
    }
    getUserInfo() {
        if (environment.useMockSessionUser) {
            return of(MOCK_SESSION_USER_RESPONSE).pipe(tap((appUser) => {
                this._appUser$.next(resolveUserInfo(appUser));
            }));
        }
        return this._http
            .get(this.API_ENDPOINT_API_INTERSOCIO + 'user', this.APP_REQUEST_OPTIONS_AUTH)
            .pipe(tap((appUser) => {
            this._appUser$.next(resolveUserInfo(appUser));
        }));
    }
    updateUserInfo(data) {
        return this._http.put(this.API_ENDPOINT_API_INTERSOCIO + 'users', { user: data }, this.APP_REQUEST_OPTIONS_AUTH);
    }
    updateUserPassword(data) {
        return this._http.put(this.API_ENDPOINT_API_INTERSOCIO + 'user/password_verified', { user: data }, this.APP_REQUEST_OPTIONS_AUTH);
    }
}
MemberService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MemberService_Factory() { return new MemberService(i0.ɵɵinject(i1.HttpClient)); }, token: MemberService, providedIn: "root" });
export { ɵ0 };
